import React from 'react';

import { Skeleton } from 'lighthouse';

export const BannerLoading = () => {
    return (
        <div className='px-5 pt-4'>
            <Skeleton height='114px' className='scale-100' />
        </div>
    );
};
